module.exports = "/next-static/_next/static/images/browserBasedZeroSetup-aefde53e5b3f99151d9aeb3d2feed0cf.png";